import request from "@/utils/request";

//user/statistical/userInfoList用户列表统计
export function userInfoList(data) {
  return request({
    url: "user/statistical/userInfoList",
    method: "post",
    data,
  });
}

//recycleUser/data/list回收员数据统计列表
export function recycleUserdata(data) {
  return request({
    url: "recycleUser/data/list",
    method: "post",
    data,
  });
}

//recycleUser/data/detail回收员顶部数据总览
export function recycleUserdatadetail(params) {
  return request({
    url: "recycleUser/data/detail",
    method: "get",
    params,
  });
}

//recycleUser/list回收员列表
export function recycleUserlist(data) {
  return request({
    url: "recycleUser/list",
    method: "post",
    data,
  });
}

//recycleUser/detail回收员详情
export function recycleUserdetail(params) {
  return request({
    url: "recycleUser/detail",
    method: "get",
    params,
  });
}

//recycleUser/save回收员信息保存
export function recyclesave(data) {
  return request({
    url: "recycleUser/save",
    method: "post",
    data,
  });
}

//frontUser/list用户绑定列表
export function frontUserlist(params) {
  return request({
    url: "frontUser/list",
    method: "get",
    params,
  });
}
//address/street/list街道列表
export function addressstreetlist(params) {
  return request({
    url: "address/street/list",
    method: "get",
    params,
  });
}
//address/community/list社区列表
export function addresscommunitylist(data) {
  return request({
    url: "address/community/list",
    method: "post",
    data,
  });
}
//frontUser/role/list角色列表
export function frontUserrolelist(params) {
  return request({
    url: "frontUser/role/list",
    method: "get",
    params,
  });
}
//recycleUser/delete回收员删除
export function recycleUserdelete(params) {
  return request({
    url: "recycleUser/delete",
    method: "get",
    params,
  });
}
//busiUser/list商家列表
export function busiUserlist(data) {
  return request({
    url: "busiUser/list",
    method: "post",
    data,
  });
}
//busiUser/save商家信息保存
export function busiUsersave(data) {
  return request({
    url: "busiUser/save",
    method: "post",
    data,
  });
}
//frontUser/checkUserBind校验前台用户绑定关系
export function frontUsercheckUserBind(data) {
  return request({
    url: "frontUser/checkUserBind",
    method: "post",
    data,
  });
}
//busiUser/delete商家删除
export function busiUserdelete(params) {
  return request({
    url: "busiUser/delete",
    method: "get",
    params,
  });
}
//busiUser/detail商家详情
export function busiUserdetail(params) {
  return request({
    url: "busiUser/detail",
    method: "get",
    params,
  });
}
//busiUser/withdraw/list提现列表
export function busiUserwithdrawlist(data) {
  return request({
    url: "busiUser/withdraw/list",
    method: "post",
    data,
  });
}
//busiUser/withdraw/audit提现审核
export function busiUserwithdrawaudit(data) {
  return request({
    url: "busiUser/withdraw/audit",
    method: "post",
    data,
  });
}
//community/statistical/register/streetList社区(注册)详情（街道分页）
export function registerstreetList(data) {
  return request({
    url: "community/statistical/register/streetList",
    method: "post",
    data,
  });
}
//user/statistical/trade/dataStatis交易数据统计
export function tradedataStatis(data) {
  return request({
    url: "user/statistical/trade/dataStatis",
    method: "post",
    data,
  });
}
//community/statistical/register/communityList社区(注册)详情（社区）
export function communityList(data) {
  return request({
    url: "community/statistical/register/communityList",
    method: "post",
    data,
  });
}
//community/statistical/register/streetListSummary社区(注册)详情（汇总）
export function streetListSummary(data) {
  return request({
    url: "community/statistical/register/streetListSummary",
    method: "post",
    data,
  });
}
//user/statistical/helpBookingOrder帮用户约单
export function helpBookingOrder(data) {
  return request({
    url: "user/statistical/helpBookingOrder",
    method: "post",
    data,
  });
}
//user/statistical/addUser添加前台用户
export function statisticaladdUser(data) {
  return request({
    url: "user/statistical/addUser",
    method: "post",
    data,
  });
}
//frontUser/costRecord线下消费记录
export function costRecord(data) {
  return request({
    url: "frontUser/costRecord",
    method: "post",
    data,
  });
}
//user/statistical/updateUser更改前台用户
export function statisticalupdateUser(data) {
  return request({
    url: "user/statistical/updateUser",
    method: "post",
    data,
  });
}
//user/statistical/addressList查询用户地址列表
export function statisticaladdressList(params) {
  return request({
    url: "user/statistical/addressList",
    method: "get",
    params,
  });
}
//user/statistical/getAppointmentTimeList上门时间查询
export function getAppointmentTimeList(params) {
  return request({
    url: "user/statistical/getAppointmentTimeList",
    method: "get",
    params,
  });
}

// 获取指导员数据列表
export function getGuidanceList(data) {
  return request({
    url: "wlGuidance/list",
    method: "post",
    data,
  });
}

export function getSaveGuidance(data) {
  return request({
    url: "/wlGuidance/save",
    method: "post",
    data,
  });
}

export function getRecoveryList() {
  return request({
    url: "/recovery/list",
    method: "get",
  });
}

export function addRecovery(data) {
  return request({
    url: "/recovery/add",
    method: "post",
    data,
  });
}

export function wlRecoveryInfoList(data) {
  return request({
    url: "/wlRecovery/wlRecoveryInfo/list",
    method: "post",
    data,
  });
}

export function wlAddressList(data = {}) {
  return request({
    url: "/wlRecovery/wlAddress/list",
    method: "post",
    data,
  });
}

export function orderSum(data){
  return request({
    url:"/wlRecovery/wlRecoveryInfo/orderSum",
    method:"post",
    data
  })
}